import React from 'react';
import PropTypes from 'prop-types';

function LeftArrow({ active, activeColor, color }) {
  return (
    <path
      d="M110.495 222.548C111.399 222.261 112.314 222.128 113.691 222.102C114.15 222.093 114.66 222.097 115.238 222.111C117.55 222.166 120.945 222.386 124.946 222.75C128.947 223.113 133.553 223.618 136.069 224.006C138.584 224.393 139.009 224.663 141.497 226.966C143.984 229.269 148.531 233.602 151.226 236.284C153.921 238.966 154.763 239.997 155.264 240.794C155.765 241.59 156.102 242.446 156.077 243.552C156.053 244.658 155.764 245.536 155.264 246.31C154.763 247.106 153.921 248.137 151.226 250.82C148.531 253.502 143.984 257.835 141.497 260.137C139.009 262.44 138.584 262.711 136.069 263.098C133.553 263.486 128.947 263.991 124.946 264.354C120.945 264.717 117.55 264.939 115.238 264.994C112.926 265.049 111.701 264.938 110.495 264.556C109.289 264.174 108.102 263.521 107.108 262.636C106.113 261.753 105.311 260.637 104.783 259.707C104.256 258.779 104.005 258.035 103.733 256.492C103.462 254.95 103.17 252.609 103.02 250.217C102.876 247.945 102.844 243.705 102.844 243.552C102.842 243.4 102.876 239.158 103.02 236.886C103.17 234.495 103.462 232.153 103.733 230.611C104.005 229.069 104.256 228.325 104.783 227.396C105.311 226.467 106.113 225.351 107.108 224.467C108.102 223.583 109.289 222.929 110.495 222.548Z"
      fill={active ? activeColor : color}
    />
  );
}

LeftArrow.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

LeftArrow.defaultProps = {
  active: false,
  activeColor: '#000000',
  color: '#D7DEE6',
};

export default LeftArrow;
